angular.module('SpidApp')
	
.factory('CartService',
		['Restangular', '_', 'Agency', '$localStorage', 'VacationService', '$state', 'Transaction', 'ConfigService',
function (Restangular,   _,   Agency,   $localStorage,   VacationService,   $state,   Transaction,   ConfigService) {
 	var CartService = {
 		
 		save: function (vacation, cart, finished, username, lastSyncDate, options) {
			options = options || {}
			
 			var transactionIsFinished = finished || false

 			if (!cart || !options.currency_rate) {
 				throw 'CartService::save() - Missing parameters'
 			}
 			
			return ConfigService.all().then(function(memo) {
 				var configServiceMemo = memo;

				var aSales = []

				var method = "POST";
				var path = "/agencies/"+configServiceMemo.agencyId+"/transactions"
				if(cart.transaction_id !== 0) {
					path = "/agencies/"+configServiceMemo.agencyId+"/transactions/" + cart.transaction_id;
				}
				var payload = {
					  vacation_id        : vacation.id
					, bill               : +cart.totalPrice.toFixed(2)
					, id                 : cart.transation_id
					, finished           : transactionIsFinished
					, agency_id          : configServiceMemo.agencyId
					, username           : username
					, last_iso_sync_date : lastSyncDate
				}

				var call = {
					'method'  : method,
					'path'    : path,
					'payload' : payload
				};

				aSales.push(call);
				
				for(var key in cart.objects){
					if(cart.objects.hasOwnProperty(key)) {
						method = "POST";
						var relative_url = "/transactions/$0.id/sales"
						if (cart.transaction_id !== 0) {
							relative_url = "/transactions/" + cart.transaction_id + "/sales";
						}

						var targetObject = cart.objects[key]
						if (targetObject.key) {
							relative_url = relative_url + '/' + targetObject.key;
						}
						var body = {}
						body.obj_id = targetObject.id
						body.parent = targetObject.parent
						body.deno_services = targetObject.deno_services
						body.obj_table_ref = targetObject.type
						body.unit = targetObject.quantity
						body.label = targetObject.label
						body.code_tva = targetObject.code_tva
						body.price = targetObject.price
						body.local_price = targetObject.localPrice
						body.equinox = targetObject.equinox
						body.weight = targetObject.weight
						body.code_affranchissement = targetObject.code_affranchissement
						body.code_destination = targetObject.code_destination
						body.currency_rate = options.currency_rate
						body.agency_id = configServiceMemo.agencyId

						call = {
							method: method,
							path: relative_url,
							payload: body
						};

						aSales.push(call);
					}
				}

				var batch = Restangular.one("batch");
				var params = {};
				params.requests = aSales;

				return batch.customPOST(params).then(function(data){
					if(data[0] !== null){
						cart.transaction_id = data[0].id;
					}


					for (var i = 1; i < data.length ; i++) {
                        if(data[i] !== null){
                            cart.objects[i-1].key = data[i].id
						}

					}

					return data
				})
			})
 		}
 	}

 	return CartService
}])